import { sendMessage } from '../../../config/utils/message'
import { CORE_API_AKADEMIK } from '../../key/api'

// API POST METHOD
export async function GantiPassword(data) {
    try {
        const response = await CORE_API_AKADEMIK.post('setup/password', data)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}